<template>
    <b-container>
        <b-row class="mb-4">
            <b-col cols="12">
                <h4 class="mb-0">평가 데이터 다운로드</h4>
            </b-col>
        </b-row>
        <b-row>
            <b-col cols="12">
                <b-card no-body body-bg-variant="white">
                    <b-tabs v-model="datacenter_actice_tab_idx"
                            active-nav-item-class="fw-500"
                            card
                            @activate-tab="preventMoveTab">
                        <b-tab active no-body title-link-class="gray-550">
                            <template #title>
                                기업별 평가 비교 다운로드
                                <b-spinner v-show="is_downlownding_comparison_file" type="grow" class="ml-1 mb-1"
                                           small/>
                            </template>
                            <div class="px-3 my-3">
                                <b-row class="border-bottom">
                                    <b-col cols="12" lg="auto">
                                        <b-form-group
                                            id="fieldset-input-comparison-download-option"
                                            label="선택 옵션:"
                                            label-for="input-comparison-download-option"
                                            label-align="right"
                                            label-size="sm"
                                            class="d-lg-flex mb-2"
                                        >
                                            <b-input-group class="w-auto ml-lg-3" size="sm">
                                                <b-form-select id="input-comparison-download-option"
                                                               v-model="comparison_download_selected_opt"
                                                               :options="comparison_download_opt"
                                                               :disabled="global_compare_disabled"
                                                />
                                            </b-input-group>
                                        </b-form-group>
                                    </b-col>
                                    <b-col cols="12" lg>
                                        <div class="text-right">
                                            <div class="d-inline-block bg-warning rounded-sm f-90 px-3 py-1">
                                                <p class="text-dark fw-500 mb-0">{{ download_guidance }}</p>
                                            </div>
                                        </div>
                                    </b-col>
                                </b-row>

                                <b-row class="align-items-end pt-2">
                                    <b-col cols="12" class="mb-3">
                                        <div class="d-flex align-items-center justify-content-between">
                                            <div class="d-flex align-items-start">
                                                <h5 class="mb-0">평가 데이터 조회</h5>
                                                <b-badge v-show="releaseHistory.length !== releaseTableRows"
                                                         class="f-70 fw-500 mt-1 ml-2 pb-1"
                                                >
                                                    {{ releaseTableRows }} 개 / 전체 {{ releaseHistory.length }} 개
                                                </b-badge>
                                            </div>

                                            <div>
                                                <b-btn variant="primary"
                                                       size="sm"
                                                       class="mr-2"
                                                       :disabled="!selected_comparison_companies.length || global_compare_disabled"
                                                       @click="downloadScoringComparisonExcel"
                                                >
                                                    다운로드
                                                </b-btn>
                                                <b-btn variant="danger" size="sm"
                                                       @click="initializeEvaluationSearchData">조회 초기화
                                                </b-btn>
                                            </div>
                                        </div>
                                    </b-col>
                                    <b-col cols="6" xl="2">
                                        <b-form-group
                                            id="fieldset-input-companyId"
                                            label="기업 Id"
                                            label-for="input-companyId"
                                            class="mb-0"
                                        >
                                            <b-form-input id="input-companyId"
                                                          v-model="releaseSearchForm.company_id"
                                                          type="number"
                                                          :disabled="global_compare_disabled"
                                                          size="sm"
                                                          trim
                                            />
                                        </b-form-group>
                                    </b-col>
                                    <b-col cols="6" xl="2">
                                        <b-form-group
                                            id="fieldset-input-companyName"
                                            label="기업명"
                                            label-for="input-companyName"
                                            class="mb-0"
                                        >
                                            <b-form-input id="input-companyName"
                                                          v-model="releaseSearchForm.company_name"
                                                          :disabled="global_compare_disabled"
                                                          size="sm"
                                                          trim
                                            />
                                        </b-form-group>
                                    </b-col>

                                    <b-col cols="12" lg="2">
                                        <b-form-group
                                            id="fieldset-input-confirmed"
                                            label="확정여부"
                                            label-for="input-confirmed"
                                            class="mb-0"
                                        >
                                            <b-form-select id="input-confirmed"
                                                           v-model="releaseSearchForm.confirmed"
                                                           :options="[
                                                    { text: ' -- 전체보기 --', value: null },
                                                    { text: '확정' , value: true },
                                                    { text: '미확정' , value: false }
                                                ]"
                                                           :disabled="global_compare_disabled"
                                                           size="sm"
                                            />
                                        </b-form-group>
                                    </b-col>
                                    <b-col cols="12" lg="2">
                                        <b-form-group
                                            id="fieldset-input-isSendMail"
                                            label="발송여부"
                                            label-for="input-isSendMail"
                                            class="mb-0"
                                        >
                                            <b-form-select id="input-isSendMail"
                                                           v-model="releaseSearchForm.is_send_mail"
                                                           :options="[
                                                    { text: ' -- 전체보기 --', value: null },
                                                    { text: '발송' , value: true },
                                                    { text: '미발송' , value: false }
                                                ]"
                                                           :disabled="global_compare_disabled"
                                                           size="sm"
                                            />
                                        </b-form-group>
                                    </b-col>
                                    <b-col cols="12" lg="2">
                                        <b-form-group
                                            id="fieldset-input-Mode"
                                            label="보고서 평가유형"
                                            label-for="input-Mode"
                                            class="mb-0"
                                        >
                                            <b-form-select id="input-Mode"
                                                           v-model="releaseSearchForm.mode"
                                                           :options="[
                                                    { text: ' -- 전체보기 --', value: null },
                                                    { text: '서면평가' , value: 'DOC' },
                                                    { text: '실사평가' , value: 'OSIS' }
                                                ]"
                                                           size="sm"
                                                           :disabled="global_compare_disabled"
                                            />
                                        </b-form-group>
                                    </b-col>
                                    <b-col cols="12" lg="2">
                                        <b-form-group
                                            id="fieldset-input-ReportChecked"
                                            label="선택기업만 보기"
                                            label-for="input-report-checked"
                                            class="mb-0"
                                        >
                                            <b-form-select id="input-report-checked"
                                                           v-model="releaseSearchForm.selected"
                                                           :options="[
                                                    { text: ' -- 전체보기 --', value: null },
                                                    { text: '선택 기업만' , value: true },
                                                    { text: '미선택 기업만' , value: false }
                                                ]"
                                                           :disabled="global_compare_disabled"
                                                           size="sm"
                                            />
                                        </b-form-group>
                                    </b-col>
                                </b-row>
                            </div>

                            <b-row no-gutters>
                                <b-col class="mb-3">
                                    <b-table :fields="comparisonTableField"
                                             :busy.sync="is_loading_report_history"
                                             :filter="releaseSearchForm"
                                             :items="releaseHistory"
                                             empty-text="해당 프로젝트의 조회된 점수 데이터가 없습니다."
                                             empty-filtered-text="해당 프로젝트의 조회된 점수 데이터가 없습니다."
                                             class="border-bottom mb-0"
                                             show-empty
                                             hover
                                             :filter-function="filterComparisonTable"
                                             :per-page="releaseTablePerRow"
                                             :current-page="releaseTableCurrentPage"
                                             @filtered="onComparisonFiltered"
                                    >

                                        <template #table-busy>
                                            <div class="d-flex align-items-center justify-content-center my-2">
                                                <strong class="text-dark f-120 mr-2">데이터 호출중...</strong>
                                                <b-spinner class="align-middle"
                                                           style="width: 1.3rem;height: 1.3rem;"></b-spinner>
                                            </div>
                                        </template>

                                        <template #cell(company_name)="data">
                                            {{ data.value }}
                                            <b-badge>{{ data.item.company_id }}</b-badge>
                                        </template>

                                        <template #cell(report_name)="data">
                                            <div class="f-90 mb-2" style="word-break: break-all;">
                                                {{ data.value }}
                                                <b-badge class="ml-2 fw-400">
                                                    {{ formatDate(data.item.time_stamp, 'YYYY년 MM월 DD일 HH시 mm분') }}
                                                </b-badge>
                                                <b-btn variant="link" size="sm" class="f-75"
                                                       :disabled="global_compare_disabled"
                                                       @click="downloadReport(data.item)"
                                                >
                                                    (다운로드)
                                                </b-btn>
                                            </div>
                                        </template>

                                        <template #cell(confirmed)="data">
                                            <b-badge :variant="data.value ? 'primary' : 'danger'" class="f-80 fw-400">
                                                {{ data.value ? '확정' : '미확정' }}
                                            </b-badge>
                                        </template>

                                        <template #cell(is_send_mail)="data">
                                            <b-badge :variant="data.value ? 'primary' : 'danger'" class="f-80 fw-400">
                                                {{ data.value ? '발송' : '미발송' }}
                                            </b-badge>
                                        </template>

                                        <template #cell(mode)="data">
                                            <b-badge :variant="data.value === 'DOC' ? 'info' : 'secondary'"
                                                     :class="['f-80 fw-400', {'text-light': data.value === 'DOC'}]"
                                            >
                                                {{ data.value === "DOC" ? "서면 보고서" : "실사 보고서" }}
                                            </b-badge>
                                        </template>

                                        <template #cell(select_comparison_company)="data">
                                            <b-form-checkbox v-model="selected_comparison_companies"
                                                             :name="`checkbox-${data.item.id}`"
                                                             :value="data.item.id"
                                                             :disabled="global_compare_disabled"
                                            >
                                                선택
                                            </b-form-checkbox>
                                        </template>
                                    </b-table>
                                </b-col>
                                <b-col cols="12">
                                    <b-pagination
                                        v-model="releaseTableCurrentPage"
                                        :total-rows="releaseTableRows"
                                        :per-page="releaseTablePerRow"
                                        :disabled="global_compare_disabled"
                                        aria-controls="my-table"
                                        align="center"
                                    ></b-pagination>
                                </b-col>
                            </b-row>
                        </b-tab>
                        <b-tab title-link-class="gray-550">
                            <template #title>
                                평가결과 데이터 전체 다운로드
                                <b-spinner v-show="is_downloading_evaluation_file" type="grow" class="ml-1 mb-1" small/>
                            </template>

                            <b-row>
                                <b-col cols="12">
                                    <div class="d-flex align-items-center justify-content-center p-4">
                                        <div>
                                            <div class="f-90 mb-2">
                                                <b-form-checkbox v-if="checkAppEnv() !== 'ksteel' && checkAppEnv() !== 'supply'"
                                                                 id="input-includeRawData"
                                                                 v-model="is_included_assessment_raw"
                                                                 :disabled="global_compare_disabled"
                                                                 size="sm"
                                                                 :checked="true"
                                                                 :unchecked-value="false"
                                                >
                                                    Raw 데이터 포함
                                                </b-form-checkbox>
                                            </div>
                                            <b-button
                                                variant="dark-border"
                                                :disabled="global_compare_disabled"
                                                @click="downloadEvaluation"
                                            >
                                                <span v-if="!is_downloading_evaluation_file">
                                                    평가결과 데이터 전체 다운로드 <fa icon="file-excel" class="ml-1"/>
                                                </span>
                                                <div v-else class="d-flex align-items-center">
                                                    파일을 준비하는 중... (최대 1분이 소요됩니다)
                                                    <b-spinner small class="mb-0 ml-2"></b-spinner>
                                                </div>
                                            </b-button>
                                            <b-button v-if="checkScoreErr" class="ml-2"
                                                      :disabled="global_compare_disabled"
                                                      @click="checkIntegrity"
                                            >
                                                답변 충돌 확인
                                                <b-spinner v-if="loadingCheckIntegrity" small
                                                           class="mb-0 ml-2"></b-spinner>
                                            </b-button>
                                        </div>
                                    </div>
                                </b-col>
                            </b-row>
                        </b-tab>
                        <b-tab title-link-class="gray-550" no-body>
                            <template #title>
                                기업별 답변 Value 파싱 및 다운로드
                                <b-spinner v-show="is_parsing_project_values || is_downloading_project_parsed_values"
                                           type="grow" class="ml-1 mb-1" small/>
                            </template>
                            <div class="p-3">

                                <b-row class="mb-4">
                                    <b-col cols="12" lg="6">
                                        <div class="d-flex align-items-start">
                                            <h5 class="mb-0">파싱 데이터 조회</h5>
                                            <b-badge v-show="parsingValuesRows > 0" class="f-70 fw-500 mt-1 ml-2 pb-1"
                                            >
                                                <span v-show="parsingValues.length !== parsingValuesRows">
                                                    {{ parsingValuesRows }} 개 / 
                                                </span>
                                                전체 {{ parsingValues.length }} 개
                                            </b-badge>
                                        </div>
                                        <div class="mt-1">
                                            <span class="bg-warning f-85 rounded px-2 py-1">
                                                복수 선택 및 선택 해제는 <code class="text-primary fw-600 text-underline">[ctrl + 클릭]</code> 하시면 됩니다.
                                            </span>
                                        </div>
                                    </b-col>
                                    <b-col cols="12" lg="6">
                                        <div class="text-right">
                                            <b-btn variant="primary" size="sm"
                                                   class="mr-2" :disabled="global_compare_disabled"
                                                   @click="parsingValuesByProject"
                                            >
                                                {{ project_code }} 프로젝트 - 데이터 파싱
                                                <b-spinner v-show="is_parsing_project_values"
                                                           style="height: 0.9rem;width: 0.9rem;"/>
                                            </b-btn>
                                            <b-btn variant="info" size="sm"
                                                   :disabled="global_compare_disabled" @click="downloadSearchResult"
                                            >
                                                조회 데이터 다운로드
                                                <b-spinner v-show="is_downloading_project_parsed_values"
                                                           style="height: 0.9rem;width: 0.9rem;"/>
                                            </b-btn>
                                        </div>
                                    </b-col>
                                </b-row>

                                <b-row>
                                    <b-col cols="12" lg="3">
                                        <b-form-group
                                            id="fieldset-input-parser-opt-company"
                                            :label="parser_value_opt_company.length ? `기업 (${parser_value_opt_company.length}개)` : '기업'"
                                            label-for="input-input-parser-opt-company"
                                        >
                                            <b-form-select id="input-parser-opt-company"
                                                           v-model="valuesSearchForm.company_id"
                                                           :options="parser_value_opt_company"
                                                           text-field="company_name"
                                                           value-field="company_id"
                                                           :select-size="5"
                                                           multiple
                                                           :disabled="global_compare_disabled"
                                            >
                                            </b-form-select>
                                        </b-form-group>
                                    </b-col>
                                    <b-col cols="12" lg="2">
                                        <b-form-group
                                            id="fieldset-input-parser-opt-question"
                                            :label="parser_value_opt_question.length ? `질문명 (${parser_value_opt_question.length}개)` : `질문명`"
                                            label-for="input-input-parser-opt-question"
                                        >
                                            <b-form-select id="input-parser-opt-question"
                                                           v-model="valuesSearchForm.question"
                                                           :options="parser_value_opt_question"
                                                           text-field="question_name"
                                                           value-field="question_code"
                                                           :select-size="5"
                                                           multiple
                                                           :disabled="global_compare_disabled"
                                            >
                                            </b-form-select>
                                        </b-form-group>
                                    </b-col>
                                    <b-col cols="12" lg="3">
                                        <b-form-group
                                            id="fieldset-input-parser-opt-criteria"
                                            :label="parser_value_opt_criteria.length ? `조건명 (${parser_value_opt_criteria.length}개)` : '조건명'"
                                            label-for="input-input-parser-opt-criteria"
                                        >
                                            <b-form-select id="input-parser-opt-criteria"
                                                           v-model="valuesSearchForm.criteria"
                                                           :options="parser_value_opt_criteria"
                                                           text-field="criteria_name"
                                                           value-field="criteria_id"
                                                           :select-size="5"
                                                           multiple
                                                           :disabled="global_compare_disabled"
                                            >
                                            </b-form-select>
                                        </b-form-group>
                                    </b-col>
                                    <b-col cols="12" lg="4">
                                        <b-form-group
                                            id="fieldset-input-parser-opt-sub_code"
                                            :label="parser_value_opt_sub_code.length ? `문항 (${parser_value_opt_sub_code.length}개)`: '문항'"
                                            label-for="input-input-parser-opt-sub_code"
                                        >
                                            <b-form-select id="input-parser-opt-sub_code"
                                                           v-model="valuesSearchForm.sub_code"
                                                           :options="parser_value_opt_sub_code"
                                                           text-field="sub_description"
                                                           value-field="sub_code"
                                                           :select-size="5"
                                                           multiple
                                                           :disabled="global_compare_disabled"
                                            >
                                            </b-form-select>
                                        </b-form-group>
                                    </b-col>
                                    <b-col cols="12" lg="3">

                                    </b-col>
                                </b-row>
                            </div>

                            <b-row no-gutters>
                                <b-col class="mb-3">
                                    <b-table id="parsing-values-table"
                                             class="border-bottom mb-0"
                                             :items="parsingValues"
                                             :fields="parsingValuesField"
                                             :per-page="parsingValuesPerRow"
                                             :current-page="parsingValuesCurrentPage"
                                             :busy="is_parsing_project_values || is_downloading_project_parsed_values || is_loading_project_values"
                                             :filter="valuesSearchForm"
                                             :filter-function="filterValuesTable"
                                             hover
                                             responsive
                                             @filtered="onValuesFiltered"
                                    >

                                        <template #table-busy>
                                            <div class="d-flex align-items-center justify-content-center my-2">
                                                <strong class="text-dark f-120 mr-2">데이터 호출 또는 파싱 또는 다운로드 중...</strong>
                                                <b-spinner class="align-middle"
                                                           style="width: 1.3rem;height: 1.3rem;"></b-spinner>
                                            </div>
                                        </template>

                                        <template #cell(company_name)="data">
                                            <span class="f-75 bgray-400 rounded px-1 mr-1">{{
                                                    data.item.company_id
                                                }}</span>
                                            <span class="f-85">{{ data.value }}</span>
                                        </template>

                                        <template #cell(criteria_name)="data">
                                            <span class="f-75 bg-info text-light rounded px-1 mr-1">{{
                                                    data.item.criteria_id
                                                }}</span>
                                            <span class="f-85">{{ data.value }}</span>
                                        </template>

                                        <template #cell(question_name)="data">
                                            <span class="f-70 bgray-400 rounded px-1 mr-1">{{
                                                    data.item.question_code
                                                }}</span>
                                            <span class="f-85">{{ data.value }}</span>
                                        </template>

                                        <template #cell(value)="data">
                                            <div style="word-break: break-all;">
                                                {{ data.value }}
                                            </div>
                                        </template>
                                        <!-- <template #cell()="data"></template> -->
                                    </b-table>
                                </b-col>
                                <b-col cols="12">
                                    <b-pagination
                                        v-model="parsingValuesCurrentPage"
                                        :total-rows="parsingValuesRows"
                                        :per-page="parsingValuesPerRow"
                                        :disabled="global_compare_disabled"
                                        aria-controls="parsing-values-table"
                                        align="center"
                                    ></b-pagination>
                                </b-col>
                            </b-row>
                        </b-tab>
                    </b-tabs>
                </b-card>
            </b-col>
        </b-row>

        <!-- 다운로드 대기 모달 -->
        <b-modal
            id="download-waiting-modal"
            ref="downloadWaitingModal"
            ne :no-close-on-backdrop="isWaitingDownload"
            :no-close-on-esc="isWaitingDownload"
            :hide-header-close="isWaitingDownload"
            modal-class="default-modal"
            @hidden="onDownloadModalHidden"
        >
            <template #modal-title>
                <fa icon="info-circle" class="mr-2"></fa>
                다운로드 처리될 때까지 시간이 소요될 수 있습니다.
            </template>

            <!-- 대기 중 상태 -->
            <div v-if="isWaitingDownload" class="text-center py-4">
                <div class="mb-3">
                    <b-spinner variant="secondary" style="width: 3rem; height: 3rem;"></b-spinner>
                </div>
                <h5 class="text-secondary mb-2">파일 생성 중...</h5>
                <p class="text-muted mb-0">{{ downloadWaitingStatus }}</p>
                <div class="mt-3 text-muted">
                    <fa icon="info-circle" class="mr-1"></fa>
                    잠시만 기다려주세요. 파일 크기에 따라 시간이 소요될 수 있습니다.
                </div>
            </div>

            <!-- 실패·시간 초과 안내 (닫기·다운로드 센터 이동은 열려 있다) -->
            <div v-else-if="downloadError" class="text-center py-4">
                <h5 class="text-danger mb-2">다운로드하지 못했습니다</h5>
                <p class="text-muted mb-0">{{ downloadError }}</p>
            </div>

            <!-- 대기 전 안내 -->
            <div v-else>
                <div class="bg-light rounded p-3 mb-3">
                    <h6 class="mb-2">
                        대기 하시겠습니까?
                    </h6>
                    <ul class="mb-0 pl-4 f-120">
                        <li class="mb-1">
                            <small>요청한 다운로드 항목은 <strong>운영관리 &gt; 다운로드 센터</strong>에서 확인하실 수 있습니다.</small>
                        </li>
                        <li>
                            <small>대기하지 않아도 이후에 다운로드 센터에서 다운로드 하실 수 있습니다.</small>
                        </li>
                    </ul>
                </div>
                <div class="alert alert-info mb-0 d-flex align-items-center">
                    <fa icon="lightbulb" class="mr-2"></fa>
                    <small><strong>TIP:</strong> 파일 용량이 큰 경우 다운로드 센터에서 확인하시는 것을 권장합니다.</small>
                </div>
            </div>

            <template #modal-footer>
                <b-button
                    variant="secondary"
                    :disabled="isWaitingDownload"
                    @click="closeDownloadModal"
                >
                    닫기
                </b-button>
                <b-button
                    variant="outline-primary"
                    :disabled="isWaitingDownload"
                    @click="goToDownloadCenter"
                >
                    다운로드 센터로 이동
                </b-button>
                <b-button
                    v-if="isWaitingDownload"
                    variant="danger"
                    @click="cancelWaitingDownload"
                >
                    <fa icon="times" class="mr-1"></fa>
                    대기 중단(서버에서는 계속 생성됩니다)
                </b-button>
                <b-button
                    v-else-if="!downloadError"
                    variant="primary"
                    @click="startWaitingDownload"
                >
                    대기 후 다운로드
                </b-button>
            </template>
        </b-modal>
    </b-container>
</template>

<script>
import axios from 'axios';
import { getErrorMessage } from '@core/utils/api/errorMessage';
import downloadFile from '@shared_mixins/downloadFile';
import * as XLSX from 'xlsx';
import {checkAppEnv, waitTime} from '@shared/utils/common';
const {integrityIssues, integrityIssueLines} = require('@shared/store/scoring-integrity-error.cjs');

export default {
    name: 'ProjectDataCenter',
    props: {
        projectCompany: {
            type: Array,
            default: () => [],
        }
    },
    components: {},
    mixins: [
        downloadFile
    ],
    data() {
        return {
            datacenter_actice_tab_idx: 0,

            // 다운로드 대기 모달 관련
            isWaitingDownload: false,
            downloadWaitingStatus: '',
            pendingDownloadInfo: null,
            pendingDownloadFileName: '',
            downloadError: '',
            // 대기 1회마다 올라가는 번호. 중단·닫기·파괴 때 올려서 진행 중인 조회 결과를 버린다
            downloadRun: 0,

            // 기업별 평가결과 비교
            is_loading_report_history: false,
            is_downloading_coparison_data: false,
            releaseHistory: [],
            comparison_download_opt: [
                {value: null, text: '개별 선택'},
                {value: 'all', text: '전체'},
                {value: 'latest', text: '기업별 최신 데이터'},
                {value: 'DOC', text: '서면평가 데이터'},
                {value: 'OSIS', text: '실사평가 데이터'},
                {value: 'confirmed', text: '확정된 케이스 데이터'},
            ],
            comparison_download_selected_opt: null,
            selected_comparison_companies: [],
            comparisonTableField: [
                {
                    key: 'company_name',
                    label: '기업명',
                    thStyle: {
                        width: '180px'
                    },
                    thClass: ['text-center'],
                    tdClass: ['align-middle'],
                    sortable: true
                },
                {
                    key: 'report_name',
                    label: '보고서명',
                    tdClass: ['align-middle'],
                    sortable: true
                },
                {
                    key: 'confirmed',
                    label: '확정여부',
                    thStyle: {
                        width: '90px'
                    },
                    thClass: ['text-center'],
                    tdClass: ['text-center align-middle'],
                    sortable: true
                },
                {
                    key: 'is_send_mail',
                    label: '발송여부',
                    thStyle: {
                        width: '90px'
                    },
                    thClass: ['text-center'],
                    tdClass: ['text-center align-middle'],
                    sortable: true
                },
                {
                    key: 'mode',
                    label: '보고서 평가유형',
                    thStyle: {
                        width: '150px'
                    },
                    thClass: ['text-center'],
                    tdClass: ['text-center align-middle'],
                    sortable: true
                },
                {
                    key: 'select_comparison_company',
                    label: '선택',
                    thStyle: {
                        width: '95px'
                    },
                    thClass: ['text-center'],
                    tdClass: ['text-center align-middle'],
                    sortable: true
                },
            ],
            releaseTableCurrentPage: 1,
            releaseTableRows: 1,
            releaseTablePerRow: 5,

            // 평가결과 비교 데이터 조회
            releaseSearchForm: {
                company_id: null,
                company_name: null,
                confirmed: null,
                is_send_mail: null,
                mode: null,
                selected: null
            },

            // 평가결과 비교 데이터 다운로드
            is_downlownding_comparison_file: false,

            // 평가결과 데이터 전체 다운로드
            is_included_assessment_raw: false,
            is_downloading_evaluation_file: false,

            // Value Parsing 및 다운로드
            is_loading_project_values: false,
            is_parsing_project_values: false,
            is_downloading_project_parsed_values: false,
            parsingValues: [],
            parsingValuesField: [
                {
                    key: 'index',
                    label: '번호',
                    thClass: ['text-center'],
                    thStyle: {
                        width: '20px'
                    },
                    tdClass: ['text-center'],
                    sortable: true
                },
                {
                    key: 'company_name',
                    label: '기업명',
                    thStyle: {
                        width: '180px'
                    },
                    sortable: true
                },
                {
                    key: 'question_name',
                    label: '질문명',
                    thStyle: {
                        width: '30px'
                    },
                    thClass: ['text-center'],
                    sortable: true
                },
                {
                    key: 'criteria_name',
                    label: '조건명',
                    thStyle: {
                        width: '125px'
                    },
                    thClass: ['text-center'],
                    sortable: true
                },
                {
                    key: 'sub_code',
                    label: '문항 코드',
                    thStyle: {
                        width: '90px'
                    },
                    thClass: ['text-center'],
                    sortable: true
                },
                {
                    key: 'sub_description',
                    label: '문항 질문',
                    thStyle: {
                        width: '180px'
                    },
                    thClass: ['text-center'],
                    tdClass: ['f-90'],
                    sortable: true
                },
                {
                    key: 'key',
                    label: 'Key',
                    tdClass: ['f-85'],
                    sortable: true
                },
                {
                    key: 'year',
                    label: '연도',
                    tdClass: ['f-85'],
                    sortable: true
                },
                {
                    key: 'value',
                    label: '값',
                    tdClass: ['f-85'],
                    sortable: true
                },
                {
                    key: 'unit',
                    label: '단위',
                    tdClass: ['f-85'],
                    sortable: true
                },
            ],
            parsingValuesCurrentPage: 1,
            parsingValuesRows: 1,
            parsingValuesPerRow: 5,
            valuesSearchForm: {
                company_id: [],
                company_name: null,
                question: [],
                criteria: [],
                sub_code: [],
            },
            selected_values_question: [],
            selected_values_criteria: [],
            selected_values_sub_code: [],

            checkScoreErr: false,
            loadingCheckIntegrity: false,
        };
    },
    computed: {
        project_code() {
            return this.$route.query.pc || this.$route.query.project_code;
        },
        campaign_id() {
            return this.$route.query.cmp || this.$route.query.campaign_id;
        },
        global_compare_disabled() {
            return this.is_downlownding_comparison_file
                || this.is_downloading_evaluation_file
                || this.is_loading_project_values
                || this.is_parsing_project_values
                || this.is_downloading_project_parsed_values
                || this.loadingCheckIntegrity;
        },
        download_guidance() {
            const _const_message = '기업 평가데이터 중 기업별 최근 데이터';
            switch (this.comparison_download_selected_opt) {
            case 'all':
                return `${_const_message}, 서면/실사 중복 기업의 경우 실사평가 데이터 선택`;
            case 'latest':
                return `${_const_message}, 서면/실사 중복 기업의 경우 실사평가 데이터 선택`;
            case 'DOC':
                return `${_const_message}, 서면평가 결과보고서 기반 데이터 선택`;
            case 'OSIS':
                return `${_const_message}, 실사평가 결과보고서 기반 데이터 선택`;
            case 'confirmed':
                return `${_const_message}, 확정된 결과보고서의 데이터 선택`;
            default:
                return '다운로드할 평가 데이터를 직접 선택해주세요.';
            }
        },
        parser_value_opt_company() {
            if (!this.parsingValues.length) {
                return [];
            } else {
                const _values_company_collection = this.parsingValues.reduce((company_set, {
                    company_id,
                    company_name
                }) => {
                    if (!company_set[company_id]) company_set[company_id] = {company_id, company_name};
                    return company_set;
                }, {});

                return Object.values(_values_company_collection);
            }
        },
        parser_value_opt_question() {
            if (!this.parsingValues.length) {
                return [];
            } else {
                const _values_question_collection = this.parsingValues.reduce((question_set, {
                    question_code,
                    question_name
                }) => {
                    if (!question_set[question_code]) question_set[question_code] = {question_code, question_name};
                    return question_set;
                }, {});

                return Object.values(_values_question_collection);
            }
        },
        parser_value_opt_criteria() {
            if (!this.parsingValues.length) {
                return [];
            } else {
                const _values_criteria_collection = this.parsingValues.reduce((criteria_set, {
                    criteria_id,
                    criteria_name
                }) => {
                    if (!criteria_set[criteria_id]) criteria_set[criteria_id] = {criteria_id, criteria_name};
                    return criteria_set;
                }, {});
                return Object.values(_values_criteria_collection);
            }
        },
        parser_value_opt_sub_code() {
            if (!this.parsingValues.length) {
                return [];
            } else {
                const _values_subs_collection = this.parsingValues.reduce((subs_set, {sub_code, sub_description}) => {
                    if (!subs_set[sub_code]) subs_set[sub_code] = {sub_code, sub_description};
                    return subs_set;
                }, {});
                return Object.values(_values_subs_collection);
            }
        }
    },
    watch: {
        global_compare_disabled(_updated_disabled) {
            this.$emit('prevent-close-dataCenter-modal', _updated_disabled);
        },
        async datacenter_actice_tab_idx(_active_idx, _deactive_idx) {
            if (_deactive_idx === 0) {
                this.initializeEvaluationData();
            } else if (_deactive_idx === 2) {
                this.initializeParsingValuesData();
            }

            if (_active_idx === 0) {
                await this.getCompanyReportReleaseHistory();
            } else if (_active_idx === 1) {
                // 조회 없음. only 다운로드
            } else {
                await this.getProjectParsingValues();
            }
        },
        comparison_download_selected_opt(_selected) {
            let _selected_comparison_companies = [];
            if (_selected === 'all') {
                _selected_comparison_companies = this.releaseHistory.reduce((_all_reports, _report) => {
                    if (!_all_reports[_report.company_id]) {
                        _all_reports[_report.company_id] = _report;
                    } else if (_all_reports[_report.company_id].mode === 'DOC' && _report.mode === 'OSIS') {
                        _all_reports[_report.company_id] = _report;
                    } else if (new Date(_all_reports[_report.company_id].time_stamp) <= new Date(_report.time_stamp)) {
                        _all_reports[_report.company_id] = _report;
                    }

                    return _all_reports;
                }, {});
            } else if (_selected === 'latest') {
                _selected_comparison_companies = this.releaseHistory.reduce((_latest_reports, _report) => {
                    if (!_latest_reports[_report.company_id]) {
                        _latest_reports[_report.company_id] = _report;
                    } else if (new Date(_latest_reports[_report.company_id].time_stamp) <= new Date(_report.time_stamp)) {
                        _latest_reports[_report.company_id] = _report;
                    }

                    return _latest_reports;
                }, {});
            } else if (_selected === 'DOC') {
                _selected_comparison_companies = this.releaseHistory.reduce((_DOC_reports, _report) => {
                    if (_report.mode === 'DOC') {
                        if (!_DOC_reports[_report.company_id]) {
                            _DOC_reports[_report.company_id] = _report;
                        } else if (new Date(_DOC_reports[_report.company_id].time_stamp) <= new Date(_report.time_stamp)) {
                            _DOC_reports[_report.company_id] = _report;
                        }
                    }

                    return _DOC_reports;
                }, {});
            } else if (_selected === 'OSIS') {
                _selected_comparison_companies = this.releaseHistory.reduce((_OSIS_reports, _report) => {
                    if (_report.mode === 'OSIS') {
                        if (!_OSIS_reports[_report.company_id]) {
                            _OSIS_reports[_report.company_id] = _report;
                        } else if (new Date(_OSIS_reports[_report.company_id].time_stamp) <= new Date(_report.time_stamp)) {
                            _OSIS_reports[_report.company_id] = _report;
                        }
                    }

                    return _OSIS_reports;
                }, {});
            } else if (_selected === 'confirmed') {
                _selected_comparison_companies = this.releaseHistory.reduce((_confirmed_reports, _report) => {
                    if (_report.confirmed === true) {
                        if (!_confirmed_reports[_report.company_id]) {
                            _confirmed_reports[_report.company_id] = _report;
                        } else if (new Date(_confirmed_reports[_report.company_id].time_stamp) <= new Date(_report.time_stamp)) {
                            _confirmed_reports[_report.company_id] = _report;
                        }
                    }

                    return _confirmed_reports;
                }, {});
            }

            this.selected_comparison_companies = Object.values(_selected_comparison_companies).map(({id}) => id);
        }
    },
    async created() {
        await this.getCompanyReportReleaseHistory();
    },
    mounted() {
    },
    destroyed() {
        this.initializeEvaluationData();
        this.downloadRun++;
    },
    methods: {
        checkAppEnv,
        async getCompanyReportReleaseHistory() {
            try {
                const _res_project_report_release_history = await this.axios('/report/history', {
                    params: {project_code: this.project_code}
                });

                let _release_history = [];
                if (_res_project_report_release_history.data.result.length) {
                    _release_history = _res_project_report_release_history.data.result.reduce((_releases, _release) => {
                        const _release_company = this.projectCompany.find(_company => _company.company_id === _release.company_id);
                        if (_release_company) {
                            _release.company_name = _release_company.company_name;
                        }
                        _releases.push(_release);
                        return _releases;
                    }, []);
                }

                this.releaseTableRows = _release_history.length;
                this.releaseHistory = _release_history;
            } catch (error) {
                alert('평가 데이터 호출 중 에러가 발생했습니다. 개발팀에 문의해주세요');
            }
        },
        async downloadScoringComparisonExcel() {
            try {
                this.is_downlownding_comparison_file = true;
                let _res_comparison_excel = await this.$axios.get('/report/satisfied-comparison', {
                    responseType: 'blob',
                    params: {id: this.selected_comparison_companies.join(',')}
                });

                let comparison_download_selected_opt_kr = this.comparison_download_opt.find(({value}) => value === this.comparison_download_selected_opt);
                comparison_download_selected_opt_kr = comparison_download_selected_opt_kr.text;

                this.downloadFileFromResponse(_res_comparison_excel, `${this.project_code} - ${comparison_download_selected_opt_kr}`);
            } catch (error) {
                alert('평가 데이터 다운로드 중 에러가 발생했습니다. 개발팀에 문의해주세요');
            } finally {
                this.is_downlownding_comparison_file = false;
            }
        },
        async downloadReport(_report) {
            const _res_report_block = await axios.get(`https://${process.env.VUE_APP_S3_BUCKET_NAME}.s3.${process.env.VUE_APP_S3_REGION_NAME}.amazonaws.com/${_report.report_path}`, {
                responseType: 'blob'
            });

            const link = document.createElement('a');
            link.href = window.URL.createObjectURL(new Blob([_res_report_block.data], {type: 'application/pdf'}));
            link.setAttribute('download', _report.report_name);
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        },
        filterComparisonTable(item) {
            let _is_item_filtered = true;
            if (this.releaseSearchForm.company_id) {
                _is_item_filtered = item.company_id == this.releaseSearchForm.company_id;
            }

            if (this.releaseSearchForm.company_name && _is_item_filtered) {
                _is_item_filtered = item.company_name.includes(this.releaseSearchForm.company_name);
            }

            if (this.releaseSearchForm.mode && _is_item_filtered) {
                _is_item_filtered = item.mode === this.releaseSearchForm.mode;
            }

            if (this.releaseSearchForm.confirmed !== null && _is_item_filtered) {
                _is_item_filtered = item.confirmed === this.releaseSearchForm.confirmed;
            }

            if (this.releaseSearchForm.is_send_mail !== null && _is_item_filtered) {
                _is_item_filtered = item.is_send_mail === this.releaseSearchForm.is_send_mail;
            }

            if (this.releaseSearchForm.selected !== null && _is_item_filtered) {
                _is_item_filtered = this.selected_comparison_companies.includes(item.id) === this.releaseSearchForm.selected;
            }

            return _is_item_filtered;
        },
        initializeEvaluationSearchData() {
            this.releaseTableCurrentPage = 1;
            this.releaseSearchForm = {
                company_id: null,
                company_name: null,
                confirmed: null,
                is_send_mail: null,
                mode: null,
                selected: null
            };
        },
        initializeEvaluationData() {
            this.is_loading_report_history = false;
            this.is_downloading_coparison_data = false;
            this.releaseHistory = [];
            this.comparison_download_selected_opt = null;
            this.selected_comparison_companies = [];
            this.releaseTableCurrentPage = 1;
            this.releaseTableRows = 1;
            this.releaseTablePerRow = 5;

            this.releaseSearchForm = {
                company_id: null,
                company_name: null,
                confirmed: null,
                is_send_mail: null,
                mode: null,
                selected: null
            };

            this.is_downlownding_comparison_file = false;
        },
        initializeParsingValuesData() {
            this.is_parsing_project_values = false;
            this.is_downloading_project_parsed_values = false;
            this.parsingValues = [];
            this.parsingValuesCurrentPage = 1;
            this.parsingValuesRows = 1;
            this.parsingValuesPerRow = 5;
            this.selected_values_question = [];
            this.selected_values_criteria = [];
            this.selected_values_sub_code = [];
        },
        onComparisonFiltered(filteredItems) {
            this.releaseTableCurrentPage = 1;
            this.releaseTableRows = filteredItems.length;
        },
        async downloadEvaluation() {
            if (checkAppEnv() === 'ksteel' || checkAppEnv() === 'supply') {
                await this.downloadEvaluationNew();
            } else {
                await this.downloadEvaluationOld();
            }
        },
        async downloadEvaluationOld() {
            this.checkScoreErr = false;
            try {
                this.is_downloading_evaluation_file = true;
                let _campaign_id = this.projectCompany[0].campaign_id ?? this.campaign_id;
                let _api_url = this.is_included_assessment_raw
                    ? `/v2/scoring?campaign_id=${_campaign_id}&project_code=${this.project_code}&as_file=true`
                    : `/v2/scoring/export/project?project_code=${this.project_code}&after_save=true&lazy=true`;

                this.downloading_evaluation = true;
                // is_included_assessment_raw가 true면 blob으로 직접 다운로드, 아니면 lazy 처리
                const response = await this.$axios.get(_api_url, this.is_included_assessment_raw ? {responseType: 'blob'} : {});

                if (!this.is_included_assessment_raw) {
                    this.pendingDownloadInfo = response.data;
                    this.pendingDownloadFileName = `${this.project_code}_스코어링_결과데이터`;
                    this.$bvModal.show('download-waiting-modal');
                } else {
                    this.downloadFileFromResponse(response, `${this.project_code}_스코어링_결과데이터`);
                }
            } catch (error) {
                if (error?.response?.status === 504) {
                    alert('요청 시간을 초과했습니다. 개발팀에 문의해주세요');
                    return;
                }
                if (error?.response?.status === 422) {
                    this.alertScoreConflict(error);
                    return;
                }
                alert('스코어링 결과 데이터 다운로드 중 에러가 발생했습니다. 개발팀에 문의해주세요');
            } finally {
                this.is_downloading_evaluation_file = false;
            }
        },
        // 다운로드 센터 항목이 만들어질 때까지(by-task) → 파일이 완성될 때까지(task-status) 차례로 묻는다.
        // 한 번에 한 요청만 보내고, 중단·닫기·파괴로 downloadRun 이 바뀌면 그 뒤 응답은 버린다.
        async waitingFileDownload(downloadInfo, fileName) {
            const run = ++this.downloadRun;
            const isStale = () => run !== this.downloadRun;
            // ponytail: 10분 상한 — 이보다 오래 걸리는 파일은 다운로드 센터에서 받는다
            const deadline = Date.now() + 10 * 60 * 1000;
            const TIMEOUT_MESSAGE = '10분이 지나도 파일이 준비되지 않았습니다. 다운로드 센터에서 확인해 주세요.';

            this.isWaitingDownload = true;
            this.downloadError = '';
            this.downloadWaitingStatus = '다운로드 ID 조회 중...';

            try {
                let downloadId = null;
                while (!downloadId) {
                    await waitTime(2000);
                    if (isStale()) return;
                    if (Date.now() > deadline) return this.failDownload(TIMEOUT_MESSAGE);
                    try {
                        const {data} = await this.$axios.get(`/download_center/by-task/${downloadInfo.task_id}`);
                        if (isStale()) return;
                        downloadId = data?.data?.id;
                    } catch (error) {
                        if (isStale() || error?.response?.status === 401) return;
                        // 다운로드 항목이 아직 안 만들어졌을 수 있어 상한까지 다시 묻는다
                    }
                }

                this.downloadWaitingStatus = '서버에서 파일을 만들고 있습니다.';
                for (;;) {
                    await waitTime(3000);
                    if (isStale()) return;
                    if (Date.now() > deadline) return this.failDownload(TIMEOUT_MESSAGE);
                    const {data: statusData} = await this.$axios.get(`/download_center/${downloadId}/task-status`);
                    if (isStale()) return;
                    // 응답(df_backend_custom app/download_center.py get_task_status, ApiResponse.ok):
                    // {success, code, message, traceId, data: {downloadStatus: pending|processing|completed|failed,
                    //  taskStatus: PENDING|SENT|STARTED|SUCCESS|FAILURE|REVOKED|LOST, isPotentiallyLost, errorMessage, ...}}
                    // 봉투 없는 모양도 받는다. 작업이 실패로 끝났는데 다운로드 상태 갱신이 실패하면 downloadStatus 가
                    // processing 으로 남으므로(_download_center.py mark_download_failed) taskStatus 종료값도 실패로 본다
                    const status = statusData?.data || statusData || {};
                    if (status.downloadStatus === 'completed') break;
                    if (status.downloadStatus === 'failed' || ['FAILURE', 'REVOKED', 'LOST'].includes(status.taskStatus)) {
                        return this.failDownload(`서버에서 파일 생성에 실패했습니다: ${status.errorMessage || '사유 없음'}`);
                    }
                    if (status.isPotentiallyLost) {
                        return this.failDownload('파일 생성 작업의 상태를 확인할 수 없습니다. 다운로드 센터에서 확인하거나 다시 요청해 주세요.');
                    }
                }

                this.downloadWaitingStatus = '다운로드 시작...';
                const response = await this.$axios.get(`/download_center/${downloadId}/presigned-url`);
                if (isStale()) return;
                const presignedUrl = response.data?.data?.presignedUrl;
                if (!presignedUrl) {
                    return this.failDownload('다운로드 주소를 받지 못했습니다. 다운로드 센터에서 받아 주세요.');
                }

                const link = document.createElement('a');
                link.href = presignedUrl;
                link.download = fileName;
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);

                this.downloadWaitingStatus = '다운로드 완료!';
                await waitTime(1500);
                if (isStale()) return;
                this.$bvModal.hide('download-waiting-modal');
            } catch (error) {
                if (isStale() || error?.response?.status === 401) return;
                this.failDownload(`${getErrorMessage(error, '상태 확인 중 오류가 발생했습니다.')} 다운로드 센터에서 확인해 주세요.`);
            }
        },
        failDownload(message) {
            this.downloadRun++;
            this.isWaitingDownload = false;
            this.pendingDownloadInfo = null;
            this.downloadWaitingStatus = '';
            this.downloadError = message;
        },

        // 다운로드 모달 관련 메서드
        closeDownloadModal() {
            this.$bvModal.hide('download-waiting-modal');
        },
        goToDownloadCenter() {
            this.$bvModal.hide('download-waiting-modal');
            this.$router.push({name: 'DownloadCenter'});
        },
        startWaitingDownload() {
            if (this.pendingDownloadInfo && this.pendingDownloadFileName) {
                this.waitingFileDownload(this.pendingDownloadInfo, this.pendingDownloadFileName);
            }
        },
        // 화면의 대기만 멈춘다. 서버 작업은 계속되고 다운로드 센터에 남는다
        cancelWaitingDownload() {
            this.downloadRun++;
            this.resetDownloadModal();
        },
        onDownloadModalHidden() {
            this.downloadRun++;
            this.resetDownloadModal();
        },
        resetDownloadModal() {
            this.isWaitingDownload = false;
            this.downloadError = '';
            this.downloadWaitingStatus = '';
            this.pendingDownloadInfo = null;
            this.pendingDownloadFileName = '';
        },
        async downloadEvaluationNew() {
            this.checkScoreErr = false;
            try {
                this.is_downloading_evaluation_file = true;
                // is_included_assessment_raw가 true면 lazy 처리 안함
                const useLazy = !this.is_included_assessment_raw;
                const response = await this.$axios.post(`/v3/scoring/summary/export?lazy=${useLazy}`, {
                    summary_target: {
                        project_code: this.project_code,
                        live: true
                    },
                    recipe: 'EV_COUNT_SUMMARY'
                }, useLazy ? {} : {responseType: 'blob'});

                if (useLazy) {
                    this.pendingDownloadInfo = response.data;
                    this.pendingDownloadFileName = `${this.project_code}_스코어링_결과데이터`;
                    this.$bvModal.show('download-waiting-modal');
                } else {
                    this.downloadFileFromResponse(response, `${this.project_code}_스코어링_결과데이터`);
                }
            } catch (error) {
                if (error?.response?.status === 504) {
                    alert('요청 시간을 초과했습니다. 개발팀에 문의해주세요');
                    return;
                }
                if (error?.response?.status === 422) {
                    this.alertScoreConflict(error);
                    return;
                }
                alert('스코어링 결과 데이터 다운로드 중 에러가 발생했습니다. 개발팀에 문의해주세요');
            } finally {
                this.is_downloading_evaluation_file = false;
            }
        },
        // 문항 안 해당없음이 섞이면 백엔드가 점수 산출을 일부러 422 로 멈춘다 (자동 보정 없음) → 막힌 문항을 알려준다.
        alertScoreConflict(error) {
            this.checkScoreErr = true;
            const issues = integrityIssues(error);
            if (issues == null) {
                alert('스코어링 결과 데이터 다운로드 중 에러가 발생했습니다. 답변 충돌 확인 버튼을 클릭하여 충돌된 답변을 확인해주세요.');
                return;
            }
            alert([
                '업체 답변과 평가자 판정의 "해당없음"이 서로 다른 문항이 있어 점수를 계산할 수 없습니다.',
                '평가 화면의 해당 문항에서 문항 단위로 해당없음/해당있음 처리하거나 초기화해 주세요.',
                '',
                ...integrityIssueLines(issues),
            ].join('\n'));
        },
        async getProjectParsingValues() {
            try {
                this.is_loading_project_values = true;
                const _res_parsing_values = await this.$axios('/parser/values', {
                    params: {project_code: this.project_code}
                });
                this.parsingValuesRows = _res_parsing_values.data.length;
                this.parsingValues = _res_parsing_values.data;
            } catch (error) {
                if (error?.response?.status === 401) return;
                this.$EventBus.$emit('toast-failure', '파서 값 조회 실패', getErrorMessage(error, '파서 값을 불러오지 못했습니다. 잠시 후 다시 시도해 주세요.'));
            } finally {
                this.is_loading_project_values = false;
            }
        },
        filterValuesTable(item) {
            let _is_item_filtered = true;
            if (this.valuesSearchForm.company_id.length) {
                _is_item_filtered = _is_item_filtered && this.valuesSearchForm.company_id.includes(item.company_id);
            }

            if (this.valuesSearchForm.company_name) {
                _is_item_filtered = _is_item_filtered && item.company_name.includes(this.valuesSearchForm.company_name);
            }

            if (this.valuesSearchForm.question.length) {
                _is_item_filtered = _is_item_filtered && this.valuesSearchForm.question.includes(item.question_code);
            }

            if (this.valuesSearchForm.criteria.length) {
                _is_item_filtered = _is_item_filtered && this.valuesSearchForm.criteria.includes(item.criteria_id);
            }

            if (this.valuesSearchForm.sub_code.length) {
                _is_item_filtered = _is_item_filtered && this.valuesSearchForm.sub_code.includes(item.sub_code);
            }

            return _is_item_filtered;
        },
        onValuesFiltered(filteredItems) {
            this.parsingValuesCurrentPage = 1;
            this.parsingValuesRows = filteredItems.length;
        },
        async parsingValuesByProject() {
            try {
                this.is_parsing_project_values = true;

                const ParserValuesForm = new FormData();
                ParserValuesForm.append('project_code', this.project_code);

                await this.$axios.post('/parser/values', ParserValuesForm);
                await this.getProjectParsingValues();
            } catch (error) {
                if (error?.response?.status === 401) return;
                this.$EventBus.$emit('toast-failure', '파서 값 추출 실패', getErrorMessage(error, '프로젝트 파서 값을 추출하지 못했습니다. 잠시 후 다시 시도해 주세요.'));
            } finally {
                this.is_parsing_project_values = false;
            }
        },
        async downloadSearchResult() {
            try {
                this.is_downloading_project_parsed_values = true;
                await this.getProjectParsingValues();
                // 화면 표와 같은 필터(AND)를 항상 적용한다
                const _download_parsed_values = this.parsingValues.filter(value => this.filterValuesTable(value) === true);

                const compliance_sheet = XLSX.utils.json_to_sheet(_download_parsed_values);
                const workbook = XLSX.utils.book_new();
                XLSX.utils.book_append_sheet(workbook, compliance_sheet, `${this.project_code} - Parser_Value`);
                XLSX.writeFile(workbook, `${this.project_code} - Parser_Value.xlsx`);
            } catch (error) {
                if (error?.response?.status === 401) return;
                this.$EventBus.$emit('toast-failure', '파서 값 다운로드 실패', getErrorMessage(error, '검색 결과 파일을 만들지 못했습니다. 잠시 후 다시 시도해 주세요.'));
            } finally {
                this.is_downloading_project_parsed_values = false;
            }

        },
        preventMoveTab(...args) {
            const bvEvent = args[args.length - 1];
            if (this.global_compare_disabled) {
                bvEvent.preventDefault();
            }
        },
        checkIntegrity() {
            this.loadingCheckIntegrity = true;
            this.$emit('checkIntegrity', false);
        }
    }
};
</script>
